module.exports = __webpack_public_path__ + "img/cloud-wind-sun.7d69d1b3.svg";